@if (showHeader) {
  <app-dashboard-header [title]="pageTitle" [dashboardType]="dashboardType"></app-dashboard-header>
}

@if (useLoadingWrapper) {
  <app-load-spinner-wrapper [loading]="loading">
    <ng-container *ngTemplateOutlet="tabContent"></ng-container>
  </app-load-spinner-wrapper>
} @else {
  <ng-container *ngTemplateOutlet="tabContent"></ng-container>
}

<ng-template #tabContent>
  <mat-tab-group
    [selectedIndex]="selectedIndex"
    (selectedTabChange)="onTabChange($event)">
    @for (tab of tabConfigs; track trackTab(tabIndex, tab); let tabIndex = $index) {
      <mat-tab
        [label]="tab.label">
        @if (tab.showSearch) {
          <div class="w-[98%] mt-12 mb-4 ml-auto mr-auto">
            <app-search
              [placeholder]="tab.searchPlaceholder || defaultSearchPlaceholder"
              (onSearch)="onTabSearch(tab.key, $event)">
            </app-search>
          </div>
        }
        <div [class]="tab.containerClass || appointmentContainerClass">
          @if (shouldRenderTabContent(tab, tabIndex)) {
            <ng-container
              *ngComponentOutlet="tab.component; inputs: tab.inputs">
            </ng-container>
          }
        </div>
        @if (tab.footerComponent) {
          <ng-container
            *ngComponentOutlet="tab.footerComponent; inputs: tab.footerInputs">
          </ng-container>
        }
      </mat-tab>
    }
  </mat-tab-group>
</ng-template>
